import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';

export function useSelectedUser() {
  const { user } = useAuth();

  const [selectedUserId, setSelectedUserId] = useState(() => {
    return localStorage.getItem('tf_selected_user') || '';
  });

  // Persist to localStorage on every change
  useEffect(() => {
    if (selectedUserId) localStorage.setItem('tf_selected_user', selectedUserId);
  }, [selectedUserId]);

  // Fall back to own ID once user object is available
  useEffect(() => {
    if (!selectedUserId && user?.id) setSelectedUserId(user.id);
  }, [user, selectedUserId]);

  return [selectedUserId, setSelectedUserId];
}
